import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, getValidUserTokens, handleError } from '@homeplay/api';
import {
  selectTokens,
  setUnitError,
  SiteContext,
  updateUserSuccess,
} from '@homeplay/app';

// NOTE: isSilent is used for a background refresh, so a failed request
// does not throw the user out of the page it was made on
export const useRefreshUserData = (isSilent = false, isEnabled = true) => {
  const { siteName, isTouchUnit } = useContext(SiteContext);
  const userTokens = useSelector(selectTokens);
  const dispatch = useDispatch();
  const [isUserLoading, setIsUserLoading] = useState(true);

  useEffect(() => {
    if (!isEnabled || !userTokens) {
      setIsUserLoading(false);
      return;
    }

    let isActive = true;

    const refreshUserData = async () => {
      setIsUserLoading(true);

      try {
        const tokens = await getValidUserTokens(
          userTokens,
          siteName,
          isTouchUnit
        );
        const user = await getUser(tokens.access.token);

        if (isActive) {
          dispatch(updateUserSuccess({ user }));
        }
      } catch (error) {
        if (isActive && !isSilent) {
          dispatch(setUnitError({ error: handleError(error, 'reload') }));
        }
      } finally {
        if (isActive) {
          setIsUserLoading(false);
        }
      }
    };

    refreshUserData();

    return () => {
      isActive = false;
    };
  }, [userTokens, isSilent, isEnabled, siteName, isTouchUnit]);

  return { isUserLoading };
};
